"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sound = function (_React$Component) {
  (0, _inherits3.default)(Sound, _React$Component);

  function Sound(props, context) {
    (0, _classCallCheck3.default)(this, Sound);
    return (0, _possibleConstructorReturn3.default)(this, (Sound.__proto__ || (0, _getPrototypeOf2.default)(Sound)).call(this, props));
  }

  (0, _createClass3.default)(Sound, [{
    key: "playSound",
    value: function playSound() {
      this.refs[this.props.nameElem].volume = 1;
      this.refs[this.props.nameElem].play();
    }
  }, {
    key: "pauseSound",
    value: function pauseSound() {
      this.refs[this.props.nameElem].volume = 0;
      this.refs[this.props.nameElem].pause();
    }
  }, {
    key: "pauseFadeOut",
    value: function pauseFadeOut(audioElement) {
      var self = this;
      var vol = 1;
      var intervalOut = 25;

      var intervalID = setInterval(function () {
        if (vol >= 0.1) {
          vol -= 0.1;
          self.refs[audioElement].volume = vol.toFixed(2);
          //console.log(vol.toFixed(2))
        } else {
          clearInterval(intervalID);
        }
      }, intervalOut);
    }
  }, {
    key: "fadeOutSound",
    value: function fadeOutSound(audioElement) {
      var self = this;
      var vol = 1;
      var intervalOut = 25;

      var intervalID = setInterval(function () {
        if (vol >= 0.5) {
          vol -= 0.5;
          self.refs[audioElement].volume = vol.toFixed(2);
          //console.log(vol.toFixed(2))
        } else {
          clearInterval(intervalID);
        }
      }, intervalOut);
    }
  }, {
    key: "playFadeIn",
    value: function playFadeIn(audioElement) {
      var self = this;
      var vol = 0;
      var interval = 25;

      if (self.refs[audioElement].paused) {
        self.refs.soundBg.play();
      }

      var intervalID = setInterval(function () {
        if (vol < 1) {
          vol += 0.05;
          self.refs[audioElement].volume = vol.toFixed(2);
        } else {
          clearInterval(intervalID);
        }
      }, interval);
    }
  }, {
    key: "render",
    value: function render() {

      return _react2.default.createElement(
        "audio",
        { id: this.props.nameElem, loop: this.props.loop, autoPlay: this.props.autoplay, ref: this.props.nameElem, className: this.props.classElem },
        _react2.default.createElement("source", { src: this.props.baseUrl + "/media/sound/" + this.props.fileName + ".mp3" }),
        _react2.default.createElement("source", { src: this.props.baseUrl + "/media/sound/" + this.props.fileName + ".ogg" })
      );
    }
  }]);
  return Sound;
}(_react2.default.Component);

exports.default = Sound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sound/Sound.js
// module id = 805
// module chunks = 0